import ShareUrl from './share-url';

export default ShareUrl;